module.exports = __webpack_public_path__ + "img/logo_russia_1.2a0d58c0.png";